import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { GoalsStrategiesSection } from './ProjectPlanningDemo';

/** Goals & Strategies tile dialog — goals, strategies, and personal
 * milestones with their existing create/edit/delete controls, unchanged. */
export default function GoalsStrategiesDialog({ open, onOpenChange, goals, setGoals, strategies, setStrategies, milestones, setMilestones }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 text-white sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="goals-strategies-dialog">
        <DialogHeader><DialogTitle className="text-white">Goals & Strategies</DialogTitle></DialogHeader>
        <GoalsStrategiesSection
          goals={goals} setGoals={setGoals}
          strategies={strategies} setStrategies={setStrategies}
          milestones={milestones} setMilestones={setMilestones}
        />
      </DialogContent>
    </Dialog>
  );
}
